














































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import Select from '@/components/Select.vue'
import {
  EEligibilityTaskStatus, IEligibilityTask, IEligibilityTaskFiltersDTO, IUser
} from '@zunta/configurations'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableColumn, ITableConfig } from '@/interfaces'
import Avatar from '@/components/Avatar.vue'
import Switcher from '@/components/Switcher.vue'
import Icon from '@/components/Icon.vue'
import './../uploads/styles/uploads.scss'
import { EligibilityTaskModule } from '@/store/modules/eligibilityTask.module'
import { User } from '@/classes/User'
import Api from '@/api'
import { UserModule } from '@/store/modules/user.module'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import EligibilityTaskSubrow from '@/views/app/admin/pages/eligibility-tasks/components/EligibilityTaskSubrow.vue'
const moment = require('moment')
const countdown = require('moment-countdown')

@Component({
  components: {
    EligibilityTaskSubrow,
    DateTimeLabel,
    Table,
    Card,
    Select,
    SearchInput,
    Avatar,
    Switcher,
    Icon
  }

})
export default class EligibilityTasks extends Vue {
  eligibilityTaskModuleInstance: EligibilityTaskModule = getModule(EligibilityTaskModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  user: User = Api.getUser() as User
  eStatuses = Object.values(EEligibilityTaskStatus)
  openedRow: any = null
  openedRowIndex: any = -1
  filters: IEligibilityTaskFiltersDTO =
    (Object.values(this.query).length && this.query) ||
    {
      skip: 0,
      limit: 20,
      isOpen: true
    }
  prevFilters: IEligibilityTaskFiltersDTO = {}
  tooltipText: string = 'Click to Copy'
  update: number = 1
  isLoading: boolean = false
  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: true,
    usePagination: true,
    useSubrow: true,
    rowClick: this.openSubrow,
    fetchFunction: this.getEligibilityTasks,
    columns: [
      {
        minWidth: '100px',
        width: 15,
        key: 'assignedTo',
        searchKey: 'assignedTo',
        label: 'Assigned',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '80px',
        width: 10,
        key: 'id',
        searchKey: 'id',
        label: 'Task ID',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 15,
        key: 'memberId',
        searchKey: 'memberId',
        label: 'Member ID',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 15,
        key: 'effectiveDateFrom',
        searchKey: 'effectiveDateFrom',
        label: 'Effective Date From',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.date
      },
      {
        minWidth: '100px',
        width: 15,
        key: 'effectiveDateTo',
        searchKey: 'effectiveDateTo',
        label: 'Effective Date To',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.date
      },
      {
        minWidth: '150px',
        width: 20,
        key: 'login',
        searchKey: 'login',
        label: 'Log in & Password'
      },
      {
        minWidth: '100px',
        width: 15,
        key: 'elapsedTime',
        searchKey: 'elapsedTime',
        label: 'Time since requested',
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 5,
        key: 'actions'
      }
    ]
  }

  get taskList (): IEligibilityTask[] {
    return this.$store.state.eligibilityTask.tasks
  }

  get total () {
    return this.$store.state.eligibilityTask.totalTasks
  }

  get isOpen () {
    return this.filters.isOpen && this.filters.isOpen !== 'false'
  }

  get query () {
    return this.$route.query
  }
  get userList () {
    return this.$store.state.user.users
  }

  getUser (assignedTo: Partial<IUser>) {
    return this.userList.find((user: any) => user.id === assignedTo.id)
  }

  async getEligibilityTasks (filters?: IEligibilityTaskFiltersDTO) {
    const filter = filters || this.query
    this.prevFilters = filter
    await this.eligibilityTaskModuleInstance.getTasksByFilters(filter)
  }

  copyText (text: string) {
    navigator.clipboard.writeText(text)
    this.tooltipText = 'Link Copied'

    setTimeout(() => {
      this.tooltipText = 'Click to Copy'
    }, 500)
  }

  async assignUserToTask (task: IEligibilityTask) {
    await this.eligibilityTaskModuleInstance.assignUserToTask({ userId: this.user.data.id, taskId: task.id })
  }

  async mounted () {
    this.$socketManager.subscribeToEligibilityTaskUpdates()
    await this.userModuleInstance.getAdminUsersList({})
  }

  async created () {
    this.$eventBus.$on('notifyEligibilityTaskUpdate', (data: { userId?: number, taskId?: number, tasksCount?: number}) => {
      if (data.taskId && data.userId) {
        const index = this.taskList.findIndex((task: IEligibilityTask) => task.id === data.taskId)
        if (index !== -1) {
          const updatedTask = {
            ...this.taskList[index],
            assignedTo: { id: data.userId }
          }
          this.$set(this.taskList, index, updatedTask)
        }
      }
    })
    this.$eventBus.$on('getEligibilityTasks', () => {
      this.eligibilityTaskModuleInstance.getTasksByFilters(this.filters)
      this.openedRowIndex = -1
      this.openedRow = null
    })
  }

  getTimestampLabel (date: Date | string) {
    const timeline = moment(date).countdown(countdown.DAYS, NaN, 1).toString()
    return timeline ? `${timeline} ago` : 'Just Now'
  }

  toggleCompletedTasks (isOpen: boolean) {
    this.filters = { limit: 20, skip: 0, isOpen }
  }

  openSubrow (row: any, index: number) {
    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      return
    }
    this.openedRowIndex = index
    this.openedRow = row
  }
}
